import $ from '../../shared/dom.js';

export default function updateClickedSlide(e) {
  const swiper = this;
  const params = swiper.params;
  const slide = $(e).closest(`.${params.slideClass}`)[0];
  let slideFound = false;
  let slideindex;

  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideindex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedindex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedindex = slideindex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedindex = undefined;
    return;
  }
  if (
    params.slideToClickedSlide &&
    swiper.clickedindex !== undefined &&
    swiper.clickedindex !== swiper.activeindex
  ) {
    swiper.slideToClickedSlide();
  }
}
